(ns rothko.editor.behaviours.mark
  (:require [com.rpl.specter :as sp]
            [rothko.editor.document.navigators :as n]
            [rothko.editor.mark.transform :as mark-transform]
            [rothko.editor.matcher :as m]
            [rothko.editor.space.transform :as space-transform]))

(def transform
  (sp/recursive-path
   [name marks]
   _
   [(sp/collect-one :selection)

    (sp/multi-path

     (sp/if-path

      (n/and-paths
       (n/context? [m/?any [{:type :space}] m/?any])
       n/end-of-token?)

      n/move-selection-one-char-to-right)

     [space-transform/remove-dangling-spaces
      (mark-transform/create (get marks name))])]))
